(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["featured-performer"] && !Shopify.designMode) return;
  try {
    class FeaturedPerformer extends HTMLElement {
    connectedCallback() {
      const facade = this.querySelector('[data-fp-embed]');
      if (!facade || facade._wired) return;
      facade._wired = true;
      facade.addEventListener('click', () => this.play(facade));
    }

    play(facade) {
      const src = facade.getAttribute('data-fp-embed');
      const title = facade.getAttribute('data-fp-title') || 'Performance video';
      if (!src) return;

      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('title', title);
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('tabindex', '-1');

      const media = facade.parentNode;
      facade.replaceWith(iframe);
      // Move focus to the player so keyboard users aren't dropped at page top.
      try { iframe.focus({ preventScroll: true }); } catch (e) { iframe.focus(); }
    }
  }

  if (!customElements.get('featured-performer')) {
    customElements.define('featured-performer', FeaturedPerformer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["maker-directory"] && !Shopify.designMode) return;
  try {
    class MakerDirectory extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;

      this.dialog = this.querySelector('[data-md-dialog]');
      this.content = this.querySelector('[data-md-content]');
      this.counter = this.querySelector('[data-md-counter]');
      this.live = this.querySelector('[data-md-live]');
      this.prevBtn = this.querySelector('[data-md-prev]');
      this.nextBtn = this.querySelector('[data-md-next]');
      this.closeBtn = this.querySelector('[data-md-close]');
      this.tiles = Array.from(this.querySelectorAll('[data-md-open]'));
      this.opener = null;
      this.index = 0;

      if (!this.dialog || this.tiles.length === 0) return;

      this.tiles.forEach((tile, i) => {
        tile.addEventListener('click', () => this.open(i, tile));
      });

      this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
      this.closeBtn && this.closeBtn.addEventListener('click', () => this.dialog.close());

      // Close when clicking the backdrop (outside the dialog content box).
      this.dialog.addEventListener('click', (e) => {
        if (e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) this.dialog.close();
      });

      // Arrow-key navigation while the modal is open.
      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
      });

      // Return focus to the tile that opened the modal.
      this.dialog.addEventListener('close', () => {
        if (this.opener && typeof this.opener.focus === 'function') this.opener.focus();
      });

      this._initLoadMore();
    }

    /**
     * Progressive "Load more": the grid is server-truncated via CSS
     * (data-md-truncated + nth-child), so this only has to tag the next
     * batch of cells as revealed and keep the button/counter in sync.
     * Modal Prev/Next still browses the full set regardless of how many
     * tiles are visible in the grid.
     */
    _initLoadMore() {
      const btn = this.querySelector('[data-md-load-more]');
      if (!btn || !this.hasAttribute('data-md-truncated')) return;

      const wrap = this.querySelector('[data-md-load-more-wrap]');
      const countEl = this.querySelector('[data-md-load-more-count]');
      const cells = Array.from(this.querySelectorAll('.md-grid > .md-cell'));
      const total = cells.length;
      const step = parseInt(this.getAttribute('data-md-step'), 10) || 4;
      let visible = Math.min(parseInt(this.getAttribute('data-md-initial'), 10) || 8, total);

      const sync = () => {
        if (countEl) countEl.textContent = 'Showing ' + visible + ' of ' + total + ' makers';
        if (visible >= total) {
          this.removeAttribute('data-md-truncated');
          if (wrap) wrap.hidden = true;
        }
      };
      sync();

      btn.addEventListener('click', () => {
        const from = visible;
        visible = Math.min(visible + step, total);
        for (let i = from; i < visible; i++) cells[i].classList.add('md-cell--revealed');
        sync();
        // Move focus to the first newly revealed tile so keyboard and screen
        // reader users land on the new content instead of a vanished button.
        const firstNew = cells[from] && cells[from].querySelector('[data-md-open]');
        if (firstNew) firstNew.focus();
      });
    }

    open(index, opener) {
      this.opener = opener || null;
      this.go(index, true);
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
    }

    go(index, silent) {
      const max = this.tiles.length - 1;
      if (index < 0) index = 0;
      if (index > max) index = max;
      this.index = index;

      const tile = this.tiles[index];
      const tmpl = tile.parentElement.querySelector('template[data-md-panel]');
      this.content.innerHTML = '';
      if (tmpl && 'content' in tmpl) {
        this.content.appendChild(tmpl.content.cloneNode(true));
      }
      this.content.scrollTop = 0;

      const name = tile.getAttribute('data-md-name') || 'Maker profile';
      this.dialog.setAttribute('aria-label', name);

      if (this.counter) this.counter.textContent = (index + 1) + ' / ' + this.tiles.length;
      if (this.prevBtn) this.prevBtn.disabled = index === 0;
      if (this.nextBtn) this.nextBtn.disabled = index === max;

      if (!silent && this.live) {
        this.live.textContent = name + ', maker ' + (index + 1) + ' of ' + this.tiles.length;
      }
    }
  }

  if (!customElements.get('maker-directory')) {
    customElements.define('maker-directory', MakerDirectory);
  }
  } catch(e) { console.error(e); }
})();

})();
